<template>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-10" v-if="error">
            <div class="text-center">
                <div class="h5">
                    Ha ocurrido un error en el proceso de devolución
                </div>
                <router-link :to="{ name: 'front.home' }" class="button button effect-button mb-0 mt-3">
                    Volver al inicio
                </router-link>
            </div>
        </div>
        <div class="col-12 col-lg-10" v-else>
            <div class="text-center">
                <div class="h5">¡Devolución realizada correctamente!</div>
                <router-link :to="{ name: 'front.home' }" class="button button effect-button mb-0 mt-3">
                    Volver al inicio
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                required: true,
                type: Boolean
            }
        }
    }
</script>